import React from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import PlaybookBuildService from "../../services/PlaybookBuildService";

import "./build-brief.css";

const CATEGORY_LABEL = "Category";
const NOT_NEEDED_LABEL = "Not needed";

class BuildBrief extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = { isOpen: !props.startsFolded };
	}

	onToggle = () => {
		this.setState(previous => ({ isOpen: !previous.isOpen }));
	};

	renderRow = field => {
		const { brief } = this.props;
		const isNotNeeded = PlaybookBuildService.isBriefFieldNotNeeded({ brief, fieldKey: field.key });
		return (
			<div key={field.key} className={clsx("build-brief__row", isNotNeeded && "build-brief__row--not-needed")}>
				<dt>{field.label}</dt>
				<dd>{isNotNeeded ? NOT_NEEDED_LABEL : brief[field.key]}</dd>
			</div>
		);
	};

	renderCategoryRow() {
		const { category } = this.props;
		return (
			<div key="category" className="build-brief__row">
				<dt>{CATEGORY_LABEL}</dt>
				<dd>
					{category.name}
					{category.isNew && <span className="tk-muted"> · new category</span>}
				</dd>
			</div>
		);
	}

	render() {
		const { fields, brief, category, title = "The brief", startsFolded } = this.props;
		const { isOpen } = this.state;
		const settledFields = fields.filter(field => PlaybookBuildService.isBriefFieldSettled({ brief, fieldKey: field.key }));
		const unsettledLabels = fields.filter(field => !settledFields.includes(field)).map(field => field.label);
		if (!category) unsettledLabels.push(CATEGORY_LABEL);
		const settledCount = settledFields.length + (category ? 1 : 0);
		const fieldCount = fields.length + 1;
		const hasSettled = settledCount > 0;
		const canFold = !!startsFolded;

		return (
			<section className="build-card tk-card">
				{canFold ? (
					<button type="button" className="build-card__head build-brief__toggle" onClick={this.onToggle} aria-expanded={isOpen}>
						<span className="build-card__title">{title}</span>
						<span className="tk-muted">
							{settledCount} of {fieldCount} answered
						</span>
						{isOpen ? (
							<Icon.ChevronUp size={16} className="build-brief__chevron" />
						) : (
							<Icon.ChevronDown size={16} className="build-brief__chevron" />
						)}
					</button>
				) : (
					<div className="build-card__head">
						<span className="build-card__title">{title}</span>
						<span className="tk-muted">
							{settledCount} of {fieldCount} answered
						</span>
					</div>
				)}
				{isOpen && hasSettled && (
					<dl className="build-brief__rows">
						{settledFields.map(this.renderRow)}
						{category && this.renderCategoryRow()}
					</dl>
				)}
				{isOpen && unsettledLabels.length > 0 && (
					<div className="build-brief__unsettled">
						<span className="tk-text-strong">Still to answer</span> {unsettledLabels.join(" · ")}
					</div>
				)}
			</section>
		);
	}
}

export default BuildBrief;
